import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../utils/i18n';
import { redirectToKakaoLogin } from '../utils/kakaoAuth';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, language } = useAuth();
  const { t } = useTranslation(language);
  const [formData, setFormData] = useState({
    username: localStorage.getItem('rememberedUsername') || '',
    password: '',
  });
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('rememberedUsername'));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleRememberChange = (e) => {
    setRememberMe(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.username, formData.password, rememberMe);

    if (result.success) {
      // Save username to localStorage if remember me is checked
      if (rememberMe) {
        localStorage.setItem('rememberedUsername', formData.username);
        localStorage.setItem('rememberMe', 'true');
      } else {
        localStorage.removeItem('rememberedUsername');
        localStorage.removeItem('rememberMe');
      }
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  const handleKakaoLogin = () => {
    console.log('[Login] Redirecting to Kakao OAuth...');
    redirectToKakaoLogin();
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <img src="/logo.jpg" alt="Wealth Roar" className="logo-img" />
          </div>
          <h1 className="login-title">{t('loginTitle')}</h1>
          <p className="login-subtitle">{t('loginSubtitle')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username" className="form-label">
              {t('username')}
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder={t('emailOrPhonePlaceholder')}
              required
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              {t('password')}
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={t('password')}
              required
              autoComplete="current-password"
            />
          </div>

          <div className="form-group-checkbox">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={handleRememberChange}
                className="checkbox-input"
              />
              <span className="checkbox-text">{t('rememberMe')}</span>
            </label>
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-sm"></span>
                {t('loggingIn')}
              </>
            ) : (
              t('login')
            )}
          </button>

          {/* Divider */}
          <div className="login-divider">
            <span>{t('or') || 'or'}</span>
          </div>

          {/* Kakao Login Button */}
          <button
            type="button"
            className="btn btn-kakao btn-block"
            onClick={handleKakaoLogin}
            disabled={loading}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 3C6.5 3 2 6.6 2 11c0 2.8 1.9 5.3 4.8 6.7-.2.9-.7 3.3-.8 3.8 0 .1 0 .3.1.4.1.1.3.1.4 0 .6-.4 3.6-2.4 4.2-2.8.4.1.9.1 1.3.1 5.5 0 10-3.6 10-8S17.5 3 12 3z"/>
            </svg>
            {t('loginWithKakao') || 'Continue with Kakao'}
          </button>
        </form>

        <div className="login-footer">
          <p className="footer-text">
            {t('contactAdmin')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
